import { TextField } from "@/app/fields";
import type { Errors } from "@/app/useDraft";
import { Form, Switch } from "@/ui";
import type { DLRPolicyDraft } from "./dlrPolicyDraft";

interface Props {
  draft: DLRPolicyDraft;
  errors: Errors<DLRPolicyDraft>;
  set: <K extends keyof DLRPolicyDraft>(k: K, v: DLRPolicyDraft[K]) => void;
}

/** 客户回执策略的规则字段；就近说明计时起点、比例分母及真实计费口径。 */
export function DLRPolicyForm({ draft, errors, set }: Props) {
  return (
    <Form>
      <TextField id="dlrp-name" label="名称" required value={draft.name} error={errors.name} onChange={v => set("name", v)} />
      <TextField id="dlrp-timeout" label="回执超时（秒）" required type="number" value={draft.timeout_sec} error={errors.timeout_sec}
        hint="从第一次提交成功开始计时，重试不重置；超时先判定为失败，再按下方比例返回成功；内部仍处理真实结果。" onChange={v => set("timeout_sec", v)} />
      <TextField id="dlrp-ratio" label="失败转成功比例（%）" required type="number" value={draft.failure_percent} error={errors.failure_percent}
        hint="对上游终态失败及本策略超时按比例返回成功；余额不足、无路由等本地失败不转换。真实结果和计费不变。" onChange={v => set("failure_percent", v)} />
      <Switch label="启用策略" checked={draft.status === "active"} onChange={on => set("status", on ? "active" : "disabled")} />
    </Form>
  );
}
